const partnerSlider = document.querySelector('.partner-main-carousel');
if (partnerSlider) {
    new Flickity(partnerSlider, {
        // options
        cellAlign: 'left',
        contain: true,
        autoPlay: 1500,
    });
}
